import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogService} from '@shared/services/dialog-service';
import {DialogModel} from '@shared/models/dialog.model';

@Injectable({
  providedIn: 'root'
})
export class CreateDataMappingCommandHandler implements IPlatformCommandHandler {
  constructor(private dialogService: DialogService) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const dialogModel = DialogModel.create(
      'Create Data Mapping',
      'CreateDataMappingDialogComponent',
      {...command.fieldValues, returns: 'single'},
      '575px',
      '575px');
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res && res.action === 'OK') {
        command.fieldValues['DataMappingName'] = res.data.input.dataMappingName;
        command.fieldValues['SplitOwnership'] = res.data.input.splitOwnership;
        if (res.data.input.selectedSource) {
          command.fieldValues['SelectedSourceConfig'] = res.data.input.selectedSource;
        }
        if (res.data.input.selectedDestination) {
          command.fieldValues['SelectedDestinationConfig'] = res.data.input.selectedDestination;
        }
        if (res.data.input.selectedDestinationItem) {
          command.fieldValues['SelectedDestinationRelativePath'] = res.data.input.selectedDestinationItem.relativePath;
          command.fieldValues['SelectedDestinationFileName'] = res.data.input.selectedDestinationItem.name;
        }
        if (res.data.input.selectedSourceItem) {
          command.fieldValues['SelectedSourceFileName'] = res.data.input.selectedSourceItem.name;
          command.fieldValues['SelectedSourceRelativePath'] = res.data.input.selectedSourceItem.relativePath;
        }
        handler.executeCommand(command);
        return true;
      }
      return false;
    });
    return false;
  }
}
